/**
 * Registro de baixas — todas as parcelas marcadas como pagas, independente
 * da origem (manual pelo operador ou automatica via webhook do gateway).
 * Serve tambem para estornar uma baixa quando o operador registra por engano.
 */

import { api } from "./api";

export type OrigemBaixa = "manual" | "automatica" | "conciliacao";

export interface Baixa {
  parcelaId: string;
  loanId: string;
  clienteId: string;
  clienteNome: string;
  parcelaNumero: number;
  parcelaValor: string;
  formaPagamento: string | null;
  dataPagamento: string | null;
  origem: OrigemBaixa;
  registradoEm: string;
  funcionarioId: string | null;
  funcionarioNome: string | null;
  funcionarioEmail: string | null;
  estornado: boolean;
  estornadoEm: string | null;
  estornadoPorNome: string | null;
}

interface Paginated<T> {
  data: T[];
  meta: { page: number; limit: number; total: number; totalPages: number };
}

export const baixasService = {
  async list(params: {
    page?: number;
    limit?: number;
    search?: string;
    onlyActive?: boolean;
    origem?: OrigemBaixa;
  } = {}): Promise<Paginated<Baixa>> {
    const qs = new URLSearchParams();
    if (params.page) qs.set("page", String(params.page));
    if (params.limit) qs.set("limit", String(params.limit));
    if (params.search) qs.set("search", params.search);
    // API assume onlyActive=true por default; envia apenas o "false" quando queremos historico.
    if (params.onlyActive === false) qs.set("onlyActive", "false");
    if (params.origem) qs.set("origem", params.origem);
    const query = qs.toString();
    const res = await api.get<Baixa[]>(
      `/installments/baixas${query ? `?${query}` : ""}`
    );
    return {
      data: res.data ?? [],
      meta: res.meta ?? { page: 1, limit: 25, total: 0, totalPages: 0 },
    };
  },

  async reverse(parcelaId: string, motivo?: string) {
    return api.post(`/installments/${parcelaId}/reverse`, { motivo });
  },
};
